import React, { useContext, useState, useEffect } from "react";

import PropTypes from "prop-types";

import {
    Backdrop,
    Box,
    LinearProgress,
    Drawer,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
} from '@mui/material';

import { useLocation } from 'react-router-dom';

import { CommonIcons, icons } from "../components/common/CommonIcons";

const AppContext = React.createContext();
const AppContextFeatures = React.createContext();

export function useAppContext() {
    return useContext(AppContext);
}

export function useAppContextFeatures() {
    return useContext(AppContextFeatures);
}

AppContextProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export function AppContextProvider({ children }) {

    const location = useLocation();

    const [appSettings, setAppSettings] = useState({
        isSidebarDocked: false,
        isNavOpen: false,
        isNavCollapse: false,
        menuHideRoutes: [], // array routes for hide menu
        isLoading: false,
        customDrawer: {},
        locationIds: [],
        zoneIds: []
    });

    const toggleSidebarDock = (status) => {
        setAppSettings((prev) => (
            { ...prev, isSidebarDocked: Boolean(status) }
        ))
    }

    const appendMenuHideRoutes = (route) => {


        setAppSettings((prev) => {

            let _newRoutes = prev.menuHideRoutes

            if (_newRoutes.includes(route) === false) {
                _newRoutes = [..._newRoutes, route]
            }

            return {
                ...prev,
                menuHideRoutes: _newRoutes
            }
        })
    }

    // const appendMenuHideRoutes = (routes) => {
    //     setAppSettings((prev) => (
    //         {
    //             ...prev,
    //             menuHideRoutes: routes
    //         }
    //     ))
    // }

    const checkCurrentRouteIsMenuHide = () => {

        let currentRoute = location.pathname
        // console.log('appSettings.menuHideRoutes', currentRoute, appSettings.menuHideRoutes)
        return appSettings.menuHideRoutes.includes(currentRoute)
    }

    const toggleNavOpen = () => {
        setAppSettings((prev) => (
            { ...prev, isNavOpen: !appSettings.isNavOpen }
        ))
    }

    const toggleNavCollapse = (status) => {
        setAppSettings((prev) => (
            { ...prev, isNavCollapse: status }
        ))
    }

    // const toggleNavToggle = (status) => {
    //     setAppSettings((prev) => (
    //         { ...prev, isNavToggle: status }
    //     ))
    // }

    const setSystemLoading = (status) => {
        setAppSettings((prev) => (
            { ...prev, isLoading: status }
        ))
    }

    const openCustomDrawer = ({
        show,
        anchor = "right",
        title,
        PaperProps = {
            sx: { width: 1 / 2 },
        },
        ComponentBody,
        ComponentActions,
        handleOnClose
    }) => {
        setAppSettings(
            {
                ...appSettings, customDrawer: {
                    show,
                    anchor,
                    title,
                    PaperProps,
                    ComponentBody,
                    ComponentActions,
                    handleOnClose
                }
            }
        )
    }

    const handleExitCustomDrawer = () => {

        setAppSettings(
            {
                ...appSettings, customDrawer: {
                    ...appSettings?.customDrawer,
                    show: false
                }
            }
        )

        if (appSettings?.customDrawer?.handleOnClose) appSettings.customDrawer.handleOnClose()

    }

    const closeCustomDrawer = () => {
        handleExitCustomDrawer()
    }

    const setLocationIds = (value) => {
        setAppSettings((prev) => (
            { ...prev, locationIds: value }
        ))
    }

    const getLocationIds = (value) => {

        return appSettings?.locationIds ? appSettings?.locationIds : []
    }

    const setZoneIds = (value) => {
        setAppSettings((prev) => (
            { ...prev, zoneIds: value }
        ))
    }

    // const getZoneIds = (value) => {
    //     return appSettings?.zoneIds? appSettings?.zoneIds : []
    // }

    useEffect(() => {

        // console.log('location', location)

        // reset the menu to show
        setAppSettings((prev) => (
            { ...prev, isMenuShow: true }
        ))

    }, [location]);

    return (
        <AppContext.Provider value={appSettings}>
            <AppContextFeatures.Provider
                value={{
                    toggleSidebarDock,
                    toggleNavOpen,
                    toggleNavCollapse,
                    appendMenuHideRoutes,
                    checkCurrentRouteIsMenuHide,
                    // toggleNavToggle,
                    setSystemLoading,
                    openCustomDrawer,
                    closeCustomDrawer,
                    setLocationIds,
                    getLocationIds,
                    setZoneIds,
                    // getZoneIds,
                    appSettings
                }}
            >

                {children}

                <Drawer
                    anchor={appSettings?.customDrawer?.anchor}
                    open={Boolean(appSettings?.customDrawer?.show)}
                    onClose={handleExitCustomDrawer}
                    PaperProps={appSettings?.customDrawer?.PaperProps}
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar
                            variant="dense"
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleExitCustomDrawer}
                                aria-label="close"
                            >
                                <CommonIcons name={icons.close} />
                            </IconButton>

                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {appSettings?.customDrawer?.title}
                            </Typography>

                            {
                                appSettings?.customDrawer?.ComponentActions
                            }

                        </Toolbar>
                    </AppBar>

                    {
                        appSettings?.customDrawer?.ComponentBody
                    }

                </Drawer>

                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1000
                    }}
                    open={Boolean(appSettings?.isLoading)}
                // onClick={handleClose}
                >
                    {/* <CircularProgress color="inherit" /> */}
                    <Box
                        sx={{
                            width: 200
                        }}
                    >
                        <LinearProgress color="inherit" />
                    </Box>

                </Backdrop>



            </AppContextFeatures.Provider>
        </AppContext.Provider>
    )

}